<template>
  <section id="location" class="py-10 md:py-16">
    <div class="container mx-auto px-4 text-center">
      <div class="max-w-3xl mx-auto mb-8 md:mb-16 text-center">
        <h2 class="text-3xl md:text-4xl font-bold text-navy mb-6">
          {{ t('localization.title') }}
        </h2>
        <div class="w-24 h-1 bg-leaf mx-auto mb-6 rounded-full"></div>
        <p class="text-lg text-muted-foreground">
          {{ t('localization.subtitle') }}
        </p>
      </div>

      <div class="h-64 md:h-96 flex justify-center">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16917.1982836337!2d14.43568378382971!3d53.49322526625073!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47aa0d041e3e3143%3A0xdc7b8ed00546e6a4!2sBor%C3%B3wka%20ameryka%C5%84ska%20z%20pilchowskich%20torfowisk%20-%20sprzeda%C5%BC!5e0!3m2!1spl!2spl!4v1747264856704!5m2!1spl!2spl"
          title="Lokalizacja plantacji borówek na mapie Google"
          width="75%"
          height="100%"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
